import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
const included = ['Manual Principal "Metabolismo Silver 21" (PDF)', 'Protocolo de 21 Días con calendario diario', 'Matriz de Intercambio Silver', 'Rutina de Movimiento Sin Daño (10 minutos)', 'Lista de Supermercado Silver', 'Acceso de por vida a todas las actualizaciones'];
export function OfferBlock() {
  return <section id="offer" className="py-16 md:py-24 bg-gradient-to-br from-forest to-forest/90" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-2xl shadow-2xl p-8 md:p-12" data-id="element-108">
          <h2 className="font-serif text-3xl md:text-4xl text-forest mb-4 text-center" data-id="element-109">
            Recupera la llave de tu metabolismo
          </h2>
          <p className="text-lg text-forest/80 text-center mb-8" data-id="element-110">
            No dejes que otro mes pase sintiéndote incómoda en tu propia piel.
          </p>

          <div className="bg-white rounded-xl p-6 mb-8" data-id="element-111">
            <h3 className="font-semibold text-forest mb-4" data-id="element-112">
              Todo lo que incluye:
            </h3>
            <ul className="space-y-3" data-id="element-113">
              {included.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-114">
                  <CheckIcon className="w-5 h-5 text-sage-dark flex-shrink-0 mt-0.5" data-id="element-115" />
                  <span className="text-forest/80" data-id="element-116">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center mb-8" data-id="element-117">
            <div className="inline-block" data-id="element-118">
              <p className="text-forest/60 text-sm mb-2" data-id="element-119">Precio Especial Hoy</p>
              <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-120">
                <span className="font-serif text-2xl md:text-3xl text-forest/40 line-through decoration-terracotta/60 decoration-2" data-id="element-121">
                  $19
                </span>
                <span className="font-serif text-5xl md:text-6xl text-terracotta" data-id="element-122">
                  $6,39
                </span>
              </div>
              <p className="text-forest/60 text-sm" data-id="element-123">USD · Pago único</p>
            </div>
          </div>

          <a href="https://tendenciasdevalor.com/cart/50034446270631:1?checkout" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full text-center bg-terracotta text-white py-5 rounded-xl font-semibold text-lg hover:bg-terracotta/90 transition-all shadow-lg hover:shadow-xl mb-6" data-id="element-124">
            ¡SÍ, QUIERO MI GUÍA AHORA!
          </a>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-forest/60" data-id="element-125">
            <div className="flex items-center gap-2" data-id="element-126">
              <LockIcon className="w-4 h-4" data-id="element-127" />
              <span data-id="element-128">Pago único</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-129">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-130" />
              <span data-id="element-131">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-132">
              <CreditCardIcon className="w-4 h-4" data-id="element-133" />
              <span data-id="element-134">100% seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}